export function tocLinkClick(event) {
    const target = event.target;
    const hash = target.hash;
    // FIXME: seems not the most elegant way to check target type
    if (!hash) {
        return;
    }
    event.stopPropagation();
    const headId = /#(.+)/.exec(hash)[1];
    const editor = target.closest(".ProseMirror");
    const heading = editor.querySelector(`[data-id='${headId}']`);
    if (!heading) {
        return;
    }
    heading.scrollIntoView({ block: "center" });
}
